var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 452.6 487.4",
    style: {
      enableBackground: "new 0 0 452.6 487.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382.7,100.9h-9.9V11.6c0-6.4-5.2-11.6-11.6-11.6H91.4C85,0,79.8,5.2,79.8,11.6v89.3h-9.9 C31.4,100.9,0,132.2,0,170.8V315c0,38.5,31.3,69.9,69.9,69.9h9.9v90.8c0,6.4,5.2,11.6,11.6,11.6h269.8c6.4,0,11.6-5.2,11.6-11.6 v-90.8h9.9c38.5,0,69.9-31.3,69.9-69.9V170.8C452.6,132.3,421.2,100.9,382.7,100.9z M103,23.3h246.5v77.6H103V23.3z M349.5,464.1 H103V320.5h246.5V464.1z M429.3,315c0,25.7-20.9,46.6-46.6,46.6h-9.9v-41.2H398c6.4,0,11.6-5.2,11.6-11.6s-5.2-11.6-11.6-11.6 h-36.8H91.4H58c-6.4,0-11.6,5.2-11.6,11.6s5.2,11.6,11.6,11.6h21.7v41.2h-9.9c-25.7,0-46.6-20.9-46.6-46.6V170.8 c0-25.7,20.9-46.6,46.6-46.6h21.5h269.8h21.5c25.7,0,46.6,20.9,46.6,46.6L429.3,315L429.3,315L429.3,315z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.2,170.6c-8.8,0-15.9,7.1-15.9,15.9s7.1,15.9,15.9,15.9s15.9-7.1,15.9-15.9 C377.1,177.8,370,170.6,361.2,170.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.2,360.7h192.1c6.4,0,11.6-5.2,11.6-11.6s-5.2-11.6-11.6-11.6H130.2c-6.4,0-11.6,5.2-11.6,11.6 S123.8,360.7,130.2,360.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.2,403.9h192.1c6.4,0,11.6-5.2,11.6-11.6s-5.2-11.6-11.6-11.6H130.2c-6.4,0-11.6,5.2-11.6,11.6 S123.8,403.9,130.2,403.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintButton);
export default __webpack_public_path__ + "static/media/print-button.050b043669b25addbdbe6cb711ad2a8b.svg";
export { ForwardRef as ReactComponent };